Drupal.behaviors.sectionFullWidth = {
  attach(context) {
    // Find all sections with additional-padding--disabled class
    const sectionsWithPaddingDisabled = context.querySelectorAll(
      '.section.additional-padding--disabled',
    );

    sectionsWithPaddingDisabled.forEach((section) => {
      // Check if this section contains any full-bleed elements
      const hasFullBleedContent = section.querySelector(
        '.paragraph-wrapper--full-bleed',
      );

      if (hasFullBleedContent) {
        // Add the full-width class to make the section span 100% of screen
        section.classList.add('full-width');
      } else {
        // Remove the full-width class if no full-bleed content is found
        section.classList.remove('full-width');
      }
    });
  },
};
